import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";

export const OverviewCardContainer = ({ children, sx, containerStyle, color }) => {
  return (
    <Card
      sx={sx}
      style={{
        boxShadow: "rgba(0, 0, 0, 0.04) 0px 5px 22px, rgba(0, 0, 0, 0.03) 0px 0px 0px 0.5px",
        backgroundColor: color,
        color: "rgb(17, 25, 39)",
        transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        overflow: "hidden",
        borderRadius: "20px",
        height: "100%",
      }}
    >
      <CardContent style={containerStyle}>{children}</CardContent>
    </Card>
  );
};
